import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AdministrationService } from '../../../../services/administration.service';
// import { WMSValidators } from '../../../../shared/validators';

@Component({
    selector: 'dialog-other-government-add-new-account-office',
    templateUrl: 'dialog.addnewaccoffice.html',
    styleUrls: ['dialog.addnewaccoffice.css']
})
export class AddNewAccountOfficeOtherGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    addaccoffform: FormGroup;
    isSubmit: boolean = false;
    errorMessage: string = '';
    //warrantAuthCode: string = 'OT';

    constructor(public dialogRef: MatDialogRef<AddNewAccountOfficeOtherGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.addaccoffform = new FormGroup({
            accOffCode: new FormControl({ value: 'System Generate', disabled: true }),
            accOff: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(32767)])
        });
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to the new Account Office?");

        if (cfm) {
            this.isSubmit = true;
            let accountOfficeDetail = {
                WarrantAuthCode: this.data.warrantauthcode,
                AccOffCode: '',
                AccOff: this.addaccoffform.get('accOff')!.value,
                MailTo: '',
                MailCc: '',
                MailBcc: ''
            }

            let save_sub = this.administrationService.othAddAccOff(accountOfficeDetail)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {

                        } else if (value.status === 200) {
                            this.isSubmit = false;
                            this.dialogRef.close('Add new successful');
                        } else {

                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}